export const faqQuestions = [
	{
		question: "Can I keep score from my Apple Watch?",
		answer: "Yes. Racketly lets you start a match and log points from your Apple Watch, so you can keep your phone off court while the score stays within reach.",
	},
	{
		question: "Which sports does Racketly support?",
		answer: "Racketly supports tennis, padel, pickleball, badminton, squash and ping pong, with scoring built around each sport.",
	},
	{
		question: "Does Racketly work on iPhone too?",
		answer: "Yes. Use Apple Watch for live scoring, then use the iPhone app to review your recorded match history and performance details.",
	},
	{
		question: "Is Racketly free to download?",
		answer: "Racketly is available to download from the App Store. Visit the store listing for the latest availability and subscription details.",
	},
];
